import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'if0009',
    ecrans: ['00-2']
});
